const TRANSLATION = {
  buyModal: {
    afterFree: 'След вашия безплатен пробен период',
    btn: 'Пробвайте безплатно',
    freeTrial: '3-дневна безплатна проба',
    monthLabel: 'месец',
    selectLabel: 'Изберете план',
    title: 'Абонатски план',
    yearLabel: 'година',
  },
  contact: {
    block1:
      'За персонализация, въпроси или предложения, моля свържете се с нас на contact@noam.tools. Ще отговорим незабавно.',
    block2: 'Подкрепете ни, като ни оцените в магазинът за разширения на Google Apps с ★★★★★.',
    block3: 'Помогнете на другите, споделете това разширение:',
    title: 'Свържете се с нас',
  },
  help: {
    AquickOverviewOfNoam: 'Бързо обобщение на Ноам',
    ChatPDF: 'Чат PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Управление на любими',
    Fixedplugin: 'Исправен Плугин',
    Focusing: 'Фокусиране',
    Free: 'Безплатно',
    FreeTrialBenefits: 'Предимства от безплатния пробен период',
    GoWithWikipedia: 'Отидете с Wikipedia',
    GoWithYouTube: 'Изишъл с YouTube',
    HoverTranslation: 'Превод при завиване',
    Howtouse: 'Как да използвате',
    ImageTranslation: 'Превод на изображения',
    InstantTranslation: 'Моментено превод',
    Membership: 'Членство',
    NoamHelp: 'Ноам ви помага да превеждате и резюмирате',
    PDFparallelTranslation: 'Паралелен превод на PDF',
    ParallelTranslation: 'Паралелен превод',
    SkipAllSteps: 'Пропуснете всички стъпки',
    Summary: 'Съдържание',
    Translation: 'Превод',
    TryItForFree: 'Попробвайте безплатно',
    Video: 'Видео',
    VideoSummary: 'Съдържание на видеото',
    VideoTranslation: 'Превод на видео',
    WebSummary: 'Уеб резюме',
    WordSelectionTranslation: 'Превод на избор на думи',
    benefits: 'Имаме предлагани ползи за вас!',
    dayFree: '3-дневен безплатен опит',
    done: 'Готова',
    next: 'Следващия',
    pin: 'Закрепете Noam за по-лесен достъп～～',
    planIsNotExist: 'Планът не е достъпен',
    startWiki: 'Да започнем с Уикимедиа!',
    startYoutube: 'Да започнем с YouTube!',
    try: 'Опитайте го',
    tryNow: 'Опитайте сега!',
  },
  home: {
    PDFTranslate: {
      desc: 'Двуезична превод + Чат с PDF',
      sub1: {
        desc: 'Двуезичното четене ви позволява да сравнявате оригиналния текст и превода страна до страна, подобрявайки ефективността на четенето.',
        title: 'Двуезично четене',
      },
      sub2: {
        desc: 'ИИ-то анализира и обобщава, а също може да отговаря на вашите въпроси въз основа на съдържанието на PDF файла.',
        title: 'Чат PDF',
      },
      sub3: {
        desc: 'PDF превод с помощта на ИИ за по-голяма точност и ефективност.',
        title: 'Точност и ефективност',
      },
      title: 'Превод на PDF',
    },
    aiAssistant: {
      desc: 'Направяне на уеб превода по умен и по удобен',
      panel1: {
        desc: 'Двуезични преводи с взаимни препратки ви помагат да сравните оригиналния текст с превода, за да разберете по-добре и да подобрите ефективността на четенето.',
        title: 'Двуезично превод',
      },
      panel2: {
        left: {
          desc: 'При разглеждане на уеб страница, превъртете мишката върху съдържанието, което трябва да преведете, за да видите превода.',
          title: 'Превод по хавър',
        },
        right: {
          desc: 'При разглеждане на уеб страница, изберете текста, който искате да преведете, за да видите превода.',
          title: 'Превод на избрания текст',
        },
      },
      panel3: {
        one: {
          desc: 'Превеждайте и обобщавайте уеб страници и видео съдържание по всяко време и навсякъде за по-безпроблемно изживяване!',
          title: 'Точка и клик',
        },
        three: {
          desc: 'Моделът на голям език с управлението на ИИ гарантира точност и последователност на превода за подобрено преживяване при четене.',
          title: 'Ориентиран към ИИ',
        },
        two: {
          desc: 'Многоезикова пълна покритие, двуезиково безбарьерно четене, превод с едно кликване - опитайте разликата!',
          title: 'По пълно и удобно',
        },
      },
      panel4: {
        tab1: {
          desc: 'Вашият експерт по ефективност - използвайки ChatGPT, Ноам превежда и обобщава съдържанието на YouTube видеа, за да ви спести време!',
          key: 'Видео',
          title: 'Превод и обобщение на видео',
        },
        tab2: {
          desc: 'Кликнете, за да преведете изображения при сърфиране в мрежата.',
          key: 'Изображение',
          title: 'Превод на изображения',
        },
        tab3: {
          desc: 'Моментално извлича ключова информация от уеб страници и предоставя резюме, подобрявайки ефективността на четенето ти.',
          key: 'Уеб',
          title: 'Уеб превод & Резюме',
        },
        tag1: 'Просто',
        tag2: 'Ефективен',
        tag3: 'Лесно разбираемо',
      },
      title: 'AI Асистент',
    },
    getStart: 'Започнете',
    getStartedForFree: 'Започнете безплатно',
    howItWork: {
      desc: 'Noam интегрира модели на изкуствения интелект, за да предостави на потребителите интелигентно изживяване за превод и обобщение на уеб страници на различни езици, превод на PDF и изображения, превод и обобщение на видео',
      title: 'Как работи',
    },
    lastBlock: { desc: 'По-добра изкуствена интелектуална превод за по-лесен опит за четене' },
    top: {
      desc: 'Noam е безплатно разширение за браузър с изкуствен интелект, което ви помага да превеждате и резюмирате уеб страници, видеа и съдържание в PDF формате.\nПрисъединете се към Noam и опитайте магията!',
      title1: 'Една Магия',
      title2: 'Един клик',
    },
    userReviews: {
      desc: 'Отзиви с петизични оценки в Chrome Web Store',
      title: 'Отзиви на потребители',
    },
  },
  installTips: {
    btn: 'Опитайте сега',
    text: 'Инсталирайте „Noam Browser Plugin“, за да отключите повече функции! Крос-референциране на уеб страници,\n    обобщение на уеб видеа и много повече!',
  },
  locale: {
    af: 'африкаанс',
    am: 'амхарски',
    ar: 'арабски',
    as: 'асамски',
    auto: 'Автоматично откриване',
    az: 'азербайджански',
    ba: 'башкирски',
    bg: 'български',
    bn: 'бангла',
    bo: 'тибетски',
    bs: 'босненски',
    ca: 'каталонски',
    cs: 'Чешки',
    cy: 'уелски',
    da: 'дания',
    de: 'немски',
    dsb: 'Dolnoserbски',
    dv: 'дивейхи',
    el: 'гръцки',
    en: 'английски език',
    es: 'испански',
    et: 'эстонски',
    eu: 'баскски',
    fa: 'персийски',
    fi: 'фински',
    fil: 'филипински',
    fj: 'фиджийски',
    fr: 'френски',
    frCA: 'френски (Канада)',
    ga: 'ирландски',
    gl: 'галисийски',
    gom: 'конкани',
    gu: 'гуджаратски',
    ha: 'хауса',
    he: 'иврит',
    hi: 'хинди',
    hr: 'хърватски',
    hsb: 'Верхненемецки сорбски',
    ht: 'хаитянски креолски',
    hu: 'унгарски',
    hy: 'арменски',
    id: 'индонезийски',
    ig: 'игбо',
    ikt: 'Инуинактун',
    is: 'исландски',
    it: 'италиански',
    iu: 'инуктитут',
    iuLatn: 'инуктикут (латински)',
    ja: 'японски',
    ka: 'грузински',
    kk: 'казахски',
    km: 'хмерски',
    kmr: 'курдски (северен)',
    kn: 'каннада',
    ko: 'корейски',
    ku: 'Курдски (централни)',
    ky: 'киргиз',
    ln: 'лингала',
    lo: 'Лао',
    lt: 'lietuvos',
    lug: 'Ганда',
    lv: 'латвийски',
    lzh: 'Китайски (литерарен)',
    mai: 'Майтили',
    mg: 'малагасийски',
    mi: 'маори',
    mk: 'македонски',
    ml: 'малаялам',
    mnCyrl: 'монголски (кирилица)',
    mnMong: 'монголски (традиционен)',
    mr: 'марати',
    ms: 'малайски',
    mt: 'малтийски',
    mww: 'Хмонг Дау',
    my: 'Мианмар (бурмански)',
    nb: 'норвежки',
    ne: 'непалски',
    nl: 'нидерландски',
    noSearchLang: 'Езикът не се поддържа',
    nso: 'Сесото са Лебоа',
    nya: 'нянджа',
    or: 'Одия',
    otq: 'Куеретаро Отоми',
    pa: 'панджаби',
    pl: 'полски',
    placeholder: 'Търсене',
    prs: 'Дари',
    ps: 'пашто',
    pt: 'португалски (Бразилия)',
    ptPT: 'португалски (Португалия)',
    ro: 'румънски',
    ru: 'руски',
    run: 'Руни',
    rw: 'киняруанда',
    sd: 'синди',
    si: 'синхала',
    sk: 'словацкий',
    sl: 'словенски',
    sm: 'самоански',
    sn: 'Шона',
    so: 'Сомалия',
    sq: 'албански',
    srCyrl: 'српски (ћирилица)',
    srLatn: 'српски (латиница)',
    st: 'сесото',
    sv: 'шведски',
    sw: 'свахили',
    ta: 'тамилски',
    te: 'телугу',
    th: 'тайски',
    ti: 'тигриня',
    tk: 'туркменски',
    tlhLatn: 'Клингон',
    tlhPiqd: 'Клингонски (pIqaD)',
    tn: 'сетсвана',
    to: 'тонгански',
    tr: 'турски',
    tt: 'татар',
    ty: 'таитски',
    ug: 'Уйгур',
    uk: 'украински',
    ur: 'урду',
    uz: 'узбекски (латиница)',
    vi: 'вьетнамски',
    xh: 'коса',
    yo: 'йоруба',
    yua: 'юкатекски майя',
    yue: 'кантонски (традиционен)',
    zh: 'китайски',
    zhHans: 'Китайски опростен',
    zhHant: 'Китайски традиционен',
    zu: 'зулу',
  },
  login: {
    and: 'и',
    btn: 'Вход с Google',
    btn1: 'Влез сега',
    desc: 'Впишете се, за да отключите повече опити',
    policy: 'Политика за поверителност',
    terms: 'Условия за ползване',
    tips: 'Създавайки акаунт, се съгласявам с',
    title: 'Добре дошли в Ноам',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Следвайте', twitter: 'Twitter' },
    legal: {
      policy: 'Политика за поверителност',
      terms: 'Условия на услугата',
      title: 'Юридически',
    },
    product: {
      image: 'Превод на изображения',
      pdf: 'Превод на PDF',
      title: 'Продукти',
      video: 'Превод и резюме на видео',
      web: 'Уеб превод и резюме',
    },
    resources: { title: 'Ресурси' },
    tools: { title: 'Инструменти', pdf: 'Превод на PDF' },
  },
  pageHeader: {
    contact: 'Контакт',
    help: 'Помощ',
    logout: 'Излизане',
    logoutSucc: 'Излизане от системата.',
    pricing: 'Ценообразование',
    settings: 'Настройки',
    signUp: 'Вход',
  },
  pdf: {
    autoDetect: 'Автоматично откриване',
    cancelBtn: 'Отказ',
    cancelUpload: 'Отказ',
    chatPdf: {
      summaryError: 'Създаването на резюме не бе успешно, моля опитайте отново по-късно',
      chatError: 'Чатът не успя, моля опитайте отново по-късно',
      Search: 'Търсене',
      cancel: 'Отказ',
      chatTitle: 'Добре дошли в Noam! Ето резюме на вашия PDF:',
      clear: 'Ясен',
      clearContent:
        'Това ще започне нов разговор. Текущото разговор няма да бъде запазено. Сигурни ли сте?',
      clearDialogTitle: 'Моля потвърдете',
      clearSucc: 'Очистен',
      copy: 'Копирай',
      copySucc: 'Копирано',
      delete: 'Изтрий',
      deleteCancel: 'Отказ',
      deleteContent: 'Този PDF не може да бъде възстановен след изтриване. Сигурни ли сте?',
      deleteOk: 'Изтрий',
      deleteSuccess: 'Изтрито',
      deleteTitle: 'Потвърдете изтриването',
      expand: 'Колапс',
      historyTitle: 'История',
      listError:
        'Неуспешно зареждане на списъка за четене. Моля, опитайте отново по-късно или се свържете с поддръжката.',
      loading: 'Зареждане...',
      noDataDesc: 'Все още няма история.',
      noMore: 'Няма повече съдържание.',
      placeholder: 'Задавайте каквото искате относно този PDF',
      summaryTitle: 'Може би ще се интересувате от тези въпроси:',
    },
    collectionEmpty: 'Вашата колекция е празна.',
    collectionTab: 'Бележки',
    dataLoading: 'Зареждане...',
    dialogContent: 'Сигурни ли сте, че искате да изтриете това?',
    dialogTitle: 'Моля потвърдете',
    download: {
      both: 'дв езичен',
      btn: 'Запази',
      cancel:
        'Затваряне на това прозорец ще прекрати свалянето на PDF файла. Сигурни ли сте, че искате да го прекратите?',
      desc: 'Запази на устройството: Изтегля преводите като изображения; Запази и отпечатай: Изтегля преводите в оригиналния формат, с поддръжка за копиране.',
      download: 'Изтегляне',
      downloadMsg1: 'Прогрес на превода на PDF:',
      downloadMsg2: 'Приблизително оставено време:',
      downloadSucc: 'PDF е готов! Натиснете, за да запишете.',
      downloadTip:
        'Изтегляне на PDF. Не затваряйте това прозорец, за да избегнете грешки при сваляне.',
      error: 'Запазването не бе успешно. Опитайте да отпечатате вместо това.',
      fileName: 'Име на файл:',
      fileType: 'Тип на файла:',
      loading: 'Запазване...',
      loading2: 'Зареждане...',
      minute: 'Минути...',
      msg1: 'Някои преводи в този документ са по-дълги от оригиналния текст и могат да се пресичат в сваленият файл. препоръчваме да четете на уеб страницата.',
      msg2: 'Преводът все още не е завършен. Моля, свалете го след като переводът приключи.',
      msg3: '2. Някои преводи са твърде дълги. Прочетете на уеб страницата, за да избегнете припокриване на текст.',
      msg4: 'Задачите за превод са в ход. Моля, опитайте отново след като бъдат завършени.',
      progress:
        'Превеждане на PDF. Прогрес: {{progress}}, Очаквано време за оставане: {{minutes}} минути...',
      save: 'Запази на устройството',
      savePrint: 'Запази и отпечатай',
      success: 'Изтеглен',
      trans: 'Само превод',
      transContinue: 'Продължете превода',
    },
    downloadBtn: 'Изтегляне',
    dragTipModal: {
      black: 'пространство',
      leftKey: 'ляв бутон',
      ok: 'Разбрах',
      press: 'Преса',
      tips: 'да влачим и гледаме',
    },
    entry: 'PDF файлове',
    fileErrMsg:
      'Четенето на файла неуспешно. Моля, опитайте отново по-късно или се свържете с поддръжката.',
    fileMsg: 'Текуща големина на файла:',
    fileMsg2: 'Моля, качете файл по-малък от 300MB.',
    freeBannerBtn: 'Актуализация',
    freeBannerTips: 'Достигнат лимитът за безплатни преводи на PDF',
    guide: {
      placeholder: 'Вмъкнете линка към PDF тук',
      start: 'Започнете превода',
      text1: 'Двъезично четене',
      text2:
        'Прочетете двуезиково, за да сравните оригиналния текст и превода страна до страна, подобрявайки ефективността си.',
      text3: 'Разговор с вашия PDF',
      text4:
        'Анализ и обобщение с помощта на ИИ. Задавайте въпроси относно вашия PDF и получавате незабавни отговори.',
      text5: 'Точен и ефективен',
      text6: 'Превод на PDF с помощта на ИИ за по-голяма точност и ефективност.',
      title1: 'Двъезична превода',
      title2: 'Разговор с вашия PDF',
      toast: 'Моля, въведете валиден онлайн PDF линк, завършващ с .pdf',
    },
    hasTransTask: 'В процес е задача за превод. Моля, изчакайте.',
    hoverTrans: 'Параграфи с превод при преминаване с мишката',
    initial: 'Превод на PDF',
    installText: 'Ваше всеобхватно решение за ежедневни преводи.',
    installText2: 'Моля, първо инсталирайте разширението',
    installTips:
      'Инсталирайте разширението за още повече преводи на PDF и по лесни преводи на уебсайтове:',
    kw: 'зависима',
    link: 'линк',
    listError:
      'Неуспешно зареждане на PDF файлове. Моля, опитайте отново по-късно или се свържете с поддръжката.',
    memoTotalCount: 'Общо 1 артикул',
    new: 'нов файл',
    noId: 'Идентификатор на файл не е намерен.',
    notPdf: 'Само PDF файлове.',
    okBtn: 'Изтрий',
    okBtn2: 'Разбрах',
    original:
      'Ти си много точен и надежден ИИ, предназначен да генерира изходен JSON, който точно отговаря на определена JSON Schema.\n\nТрябва да спазвате следните правила:\n1. Строго спазвайте структурата на JSON Schema.\n2. Точно съвпаднете с всички типове данни, задължителни полета и ограничения.\n3. НЕ включвайте никакъв допълнителен текст, обяснение, маркдаун или коментари.\n4. Извеждайте САМО обекта JSON — без блокове с код, без предисловие, без обвивка.\n\nИнформацията за схемата е предоставена по-долу.\n- Име на схема: translate_result\n- JSON Schema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Паралелен',
    parseErrDialogContent:
      'Този линк към PDF не може да се преведе директно. Моля, свалете PDF файла и го качете за превод.',
    parseErrTips: 'Неуспешно парсиране на файла',
    parseFileToast:
      'Неуспешно парсиране на файла. Моля, опитайте отново по-късно или се свържете с поддръжката.',
    pdfLoading: 'Анализиране...',
    searchPlaceholder: 'Търсене',
    selectTrans: 'Изберете текст за превод',
    shareBtn: 'Сподели',
    shareBtnText1: 'Генерирай връзка за споделяне',
    shareBtnText2: 'Обновяване на споделеното съдържание',
    shareModal: {
      cancel: 'Отказ',
      copy: 'Копирай',
      copySucc: 'Линкът е копиран',
      custom: 'Персонализиране:',
      errMsg:
        'Избраното съдържание все още не е напълно преведено. Моля, преведете го преди споделяне.',
      gen: 'Сподели',
      modify: 'Редактиране',
      notSupport: 'Този език в момента не се поддържа.',
      page: 'Страници',
      pageNuErr: 'Моля, въведете валиден номер на страница.',
      range: 'Обхват:',
      remain: 'оставящ',
      remain1: 'Обща оценена време:',
      search: 'Търсене',
      settings: 'Настройки за споделяне:',
      shareSetting: 'Настройки за споделяне',
      shareText: 'Сподели',
      shareTips: ' споделете връзката към преведеният PDF с приятелите си:',
      sourceLang: 'От:',
      target: 'До:',
      text1: 'Настройки за споделяне',
      text2: 'Генерирай връзка за споделяне',
      totalPage: 'Общо 1 страница',
      trans: 'Превод',
      translateTips:
        'Съвет: Ако преводът отнема известно време, можете да затворите това прозорец и да споделите по-късно.',
      translating: 'Превеждане на PDF...',
      update: 'Актуализиране на връзката за споделяне',
    },
    shareMsg1: 'Генериран е линк за споделяне.',
    shareMsg2: 'Споделеното съдържание е актуализирано.',
    shareMsg3:
      'Неуспешно генериране на връзка за споделяне. Моля, опитайте отново по-късно или се свържете с поддръжката.',
    shareMsg4:
      'Неуспешно актуализиране на споделеното съдържание. Моля, опитайте отново по-късно или се свържете с поддръжката.',
    shareTips: 'Преводът на вашия PDF е готов! Споделете го с приятелите си.',
    start: 'Започнете безплатния ви опит',
    thumbnail: 'Съдържание',
    toast1: 'Зареждане на PDF. Моля, опитайте отново по-късно.',
    toast2: 'Съдържанието на PDF се обработва. Диалогът в момента не се поддържа.',
    toast3: 'Изтегляне. Моля, опитайте отново след приключване на изтеглянето.',
    toolbar: { Adjust: 'Регулирай', autoFit: 'Автоматично подгоняване' },
    trans: 'Превод',
    transSucc: 'Преводът е успешен!',
    unLoginToast: 'Моля влезте в профила си, за да използвате тази функция.',
    uploadBtn: 'Качване',
    uploadErr:
      'Качването на файла не бе успешно. Моля, опитайте отново по-късно или се свържете с поддръжката.',
    uploadErrSignUrl:
      'Неуспешно зареждане на URL за качване. Моля, опитайте отново по-късно или се свържете с поддръжката.',
    uploadMsg1: 'Преместване и пусане на файла тук.',
    uploadMsg2: 'Поддържани типове файлове: PDF  |  Максимален размер на файла: 300MB',
    uploadMsg3: 'Кликнете за избор или влачете и пуснете файлове тук.',
    uploading: 'Качване',
    uploadingMsg: 'Качване. Моля, изчакайте.',
    uploadingMsg1: 'Файлът се качва. Моля, опитайте отново по-късно.',
    uploadingMsg2: 'В момента се конвертира файл. Моля, опитайте отново по-късно.',
    uploadingMsg3:
      'Запитването за напредък на конвертирането се провали. Моля, опитайте отново по-късно или се свържете с поддръжката.',
    uploadingMsg4:
      'Ноам не може да достъпва локални файлове. Моля, ръчно качете PDF файл за превод.',
    uploadingMsg5:
      'Неуспешно извличане на URL на файла. Моля, опитайте отново по-късно или се свържете с поддръжката.',
    video: 'видео',
    vipBannerBtn: 'Актуализация',
    vipBannerTips: 'Достигнахте лимита си за превод на PDF файлове за този месец.',
    webTrans: 'Пълно кръстно препратяване',
  },
  pricing: {
    FAQ: 'ЧЗВ',
    FQAObj: {
      a1: 'Да, Noam предлага безплатен план, който можете да използвате веднага.',
      a2: 'Предлагаме три плана за членство: Pro, Pro+ и Enterprise. Можете да изберете месечен или годишен плащане. Годишното фактуриране предлага значителни спестявания.',
      a3: 'Всички функции са достъпни в двата плана. Основната разлика е цената: годишните абонаменти общо струват по-малко. Месечните абонаменти се фактурират всеки месец, докато годишните планове се фактурират веднъж годишно.',
      a4: 'Можете да отмените абонамента си по всяко време в Настройките на профила си.',
      q1: 'Има ли безплатен план?',
      q2: 'Какви планове за ценообразуване и опции за плащане са налични?',
      q3: 'Каква е разликата между месечен и годишен абонамент?',
      q4: 'Как да отменя абонамента си?',
    },
    around: 'Около',
    billedMonthly: 'Фактурираме месечно',
    billedYearly: 'Фактуриране годишно',
    day: 'ден',
    desc: 'Сравнете плановете и изберете най-добрия',
    detailedCompare: 'Сравнете плановете',
    discount: '20% отстъпка',
    enterprise: {
      benefit1: 'Приоритетна поддръжка на клиенти',
      benefit2: 'Много потребители',
      benefit3: 'Персонализирани решения',
      benefit5: 'Посветен мениджър на сметки',
      btn: 'Свържете се с нас',
      recommendText: 'Персонализирани планове (≥3 човека)',
      talkToUs: 'Свържете се с нас',
    },
    free: {
      benefit1: 'Моментено превод 100 пъти/ден',
      benefit2: 'Превод и резюме на уебсайт',
      benefit3: '30 превода на изображения',
      benefit4: 'Превод и резюме на видео',
      benefit5: '10 превода на PDF',
      benefit6: '5 000 токена',
      btn: 'Опитайте безплатно',
      recommendText: 'Безплатен пробен период',
    },
    imageTranslation: 'Превод на изображения',
    month: 'месец',
    monthly: 'Месечен',
    pageTitle: 'Ценообразуване',
    pdf: {
      chat: 'PDF разговори с заявки',
      maxPage: 'Макс. страници на PDF',
      translation: 'Превод на PDF',
    },
    preMonth: 'На месец',
    pro: {
      benefit1: 'Приоритетна Поддръжка на Клиенти',
      benefit2: '1 000 000 токена/месец',
      benefit3: 'Превод и резюме на уебсайт',
      benefit4: '200 превода на изображения',
      benefit5: 'Превод и резюме на видео',
      benefit6: '200 превода на PDF',
      btn: 'Започнете',
      recommendText: 'Най-популярни',
    },
    proPlus: {
      benefit1: 'Приоритетна поддръжка на клиенти',
      benefit2: '3 000 000 токена/месец',
      benefit3: 'Превод и резюме на уебсайт',
      benefit4: '500 превода на изображения',
      benefit5: 'Превод и резюме на видео',
      benefit6: '500 превода на PDF',
      recommendText: 'Най-добрата стойност',
    },
    video: { summary: 'С резюме на видеото', translation: 'Превод на видео' },
    web: {
      contrastiveTranslation: 'Двуезиково превод',
      dictionaryTranslation: 'Избор на превод',
      hoverTranslation: 'Превод при зависване',
      instantTranslation: 'Моментено превод',
      summary: 'Създаване на резюме на уеб страница',
    },
    yearly: 'Годишно',
  },
  privacy: {
    block1:
      'Noam ("Noam", "ние", "нашите" или "нас") уважава вашата поверителност и се ангажира да защитава всяка информация, която получаваме от вас или относно вас. Тази Политика за поверителност описва нашите практики относно събиране или използване на лична информация от използването на нашия уебсайт, приложения и услуги (общо наричани „Услуги“). Тази Политика за поверителност не прилага се към съдържанието, което обработваме от името на клиентите на нашите бизнес продукти, като нашето API. Използването на тези данни е регулирано от договора ни с клиентите, който покрива достъпа до и използването на тези продукти.',
    block10:
      'Прилагаме търговски разумни технически, административни и организационни мерки за защита на онлайн и офлайн лични данни от загуба, злоупотреба, неразрешено достъп, разкриване, промяна или враждебни действия. Однако, никое интернет или имейл предаване не може да гарантира пълна сигурност или точност. По-специално, имейлите изпратени до нас или от нас може да не са сигурни. Затова трябва да бъдете особено внимателни при решаването какво информация да ни изпратите чрез услугата или имейл. Освен това, не носим отговорност за каквато и да е пречка в настройките за поверителност или сигурностни мерки в услугата или сигурностните настройки или мерки на уебсайтовете на трети страни. Ще пазим вашите лични данни за толкова дълго, колкото е необходимо за да ви предоставяме услуги или за други законни бизнес цели, като разрешаване на спорове, причини свързани с сигурността и безопасността или спазване на нашите правни задължения. Продължителността на保时янето на личните данни ще зависи от много фактори, като количество, характер, чувствителност на информацията, потенциални рискове от неразрешено използване или разкриване, целите, за които обработваме информацията, и други юридически обвързващи разсъждения.',
    block11:
      'Може да актуализираме тази Политика за поверителност от време на време. При това ще публикуваме актуализираната версия на тази страница, освен ако приложимото законодателство не предписва иного.',
    block12:
      'Ако имате неподanswered въпроси или опасения относно тази Политика за поверителност, моля, свържете се с нашия обслужване на клиенти. Email:',
    block2: 'Събираме следната лична информация („Лична информация“) свързана с вас:',
    block3:
      'Информация, предоставена от вас: При създаването на профил за ползване на нашите услуги или комуникацията с нас, ние събираме лична информация както следва:',
    block4:
      'Лична информация, автоматично получена от вашето използване на услугите: При достъп, използване или взаимодействие с услугите получаваме следната информация за вашия достъп, използване или взаимодействие („Техническа информация“):',
    block5: 'Може да използваме лични данни за следните цели:',
    block6:
      'Съкратена или обезличена информация: Можем да обединяваме или обезличим лична информация, за да предотвратим нейното повторно използване с цел идентификация, и да използваме такава информация за анализ на ефективността на нашите услуги, подобряване и добавяне на функционалности към нашите услуги, провеждане на изследвания и за подобни цели. Освен това можем да анализираме общия поведение и характеристики на потребителите на нашите услуги и да споделяме обединена информация с трети страни, да публикуваме такава обединена информация или да я направим общо достъпна. Можем да събираме обединена информация чрез услугите, чрез бисквитки и чрез други средства, описани в настоящата Политика за поверителност. Ще поддържаме и използваме обезличена информация в анонимна или обезличена форма и няма да се опитваме да я идентифицираме повторно, освен ако не е поискано по закон.',
    block7:
      'В определени случаи можем да предоставим вашата лична информация на трети страни без допълнително уведомление за вас, освен ако не е поискано по закон:',
    block8:
      'В зависимост от вашето географско местоположение, лицата в Европейската икономическа зона, Обединеното кралство и по целия свят могат да имат определени законни права относно личните им данни. Например, можете да имате право да:',
    block9:
      'Услугата може да съдържа връзки към други уебсайтове, които не са управлявани или контролирани от Noam, включително социални мрежи ("уебсайтове на трети страни"). Информацията, която споделяте с уебсайтовете на трети страни, ще бъде регулирана от специфичните политики за поверителност и условия на услугата на уебсайтовете на трети страни, а не от настоящата Политика за поверителност. Ние предоставяме тези връзки за удобство и не подразбираме нашето одобрение или преглед на тези уебсайтове. Моля, свържете се директно с уебсайтовете на трети страни за информация относно техните политики за поверителност и условия.',
    subBlock1:
      'Информация за профила: При създаването на профил в нашата платформа събираме информация, свързана с вашия профил, включително вашето име, контактна информация, данни за достъп до профила, информация за плащане с кредитна/дебитна карта и история на транзакциите („Информация за профила“).',
    subBlock10: 'Предоставяне, управление, поддържане и/или анализ на услуги;',
    subBlock11: 'Коммуникиране с вас',
    subBlock12: 'Разработване на нови продукти и услуги;',
    subBlock13:
      'Предотвратяване на измама, криминална дейност или злоупотреба с нашите услуги, както и защитаване на сигурността на нашите ИТ системи, архитектура и мрежи;',
    subBlock14: 'Извършване на бизнес прехвърляния;',
    subBlock15:
      'Соблюдаване на правни задължения и правни процеси, защита на нашите права, поверителност, сигурност или собственост, както и на тези на нашите филиали, вас или други трети страни.',
    subBlock16:
      'Доставчици и доставчици на услуги: За да ни помогнат да задоволим нуждаите за оперативна дейност на бизнеса и да изпълним определени услуги и функции, можем да предоставим лична информация на доставчици и доставчици на услуги, включително доставчици на хостинг услуги, доставчици на облачни услуги и други доставчици на информационни технологии, софтуер за електронна поща и доставчици на услуги за уеб анализ, и т.н. Тези партньори ще имат достъп, ще обработват или ще съхраняват лична информация единствено по нашето указание при изпълнение на техните длъжности към нас.',
    subBlock17:
      'Търговски прехвърляния: Ако участваме в стратегически сделки, реорганизации, банкрути, придобивания на банкрутни предприятия или преход на услуги към друг доставчик (общо наричани „Сделки“), вашата лична информация и друга информация могат да бъдат споделени с контрагенти на сделките и други страни, които помагат при изпълнението на Сделките по време на проверка на дълбочината, и да бъдат прехвърлени като част от Сделките заедно с други активи на наследник или филиална компания.',
    subBlock18:
      'Юридически изисквания: Може да споделим Вашата лична информация с правителствени органи, колеги от индустрията или други трети страни, включително информацията за Вашето взаимодействие с нашите услуги, (1) ако е поискано по закон или ако считаме, че такова действие е необходимо за спазване на юридическите задължения; (2) за защита и отстъпване на нашите права или собственост; (3) ако единсторонно установиме, че има нарушение на нашите условия, политики или закони; (4) за откриване или предотвратяване на измама или други незаконни дейности; (5) за защита на нашите продукти, служители или потребители, или на обществената безопасност, сигурност, цялостност; или (6) за защита срещу юридическа отговорност.',
    subBlock19: 'Достъпете лична информация и информация за начина, по който тя се обработва.',
    subBlock2:
      'Когато използвате нашите услуги, събираме лични данни от вашите въвеждания, качени файлове или обратна връзка, предоставена на нас („Съдържание“).',
    subBlock20: 'Изискване за изтриване на личната ви информация от нашите записи.',
    subBlock21: 'Поправете или актуализирайте личните си данни.',
    subBlock22: 'Пренесете вашата лична информация на трета страна (преносимост на данни).',
    subBlock23: 'Ограничете начина, по който обработваме вашата лична информация.',
    subBlock24:
      'Оттеглете съгласието си — когато разчитаме на съгласието като правна основа за обработване, можете да го оттеглите по всяко време.',
    subBlock25: 'Въведете жалба срещу начина, по който обработваме вашата лична информация.',
    subBlock26: 'Улучшаване на нашите услуги и провеждане на изследвания;',
    subBlock3:
      'Информация за комуникацията: Ако ни изпращате съобщения, ще съберем вашето име, контактна информация и съдържанието на вашите съобщения („Информация за комуникацията“).',
    subBlock4:
      'Информация за социалните медии: имаме страници на уебсайтове за социални медии като Instagram, Facebook, Medium, Twitter, YouTube и LinkedIn. При взаимодействието ви с нашите страници в социалните медии събираме личната информация, която изберете да ни предоставите, като Вашите контактни данни („социална информация“). Освен това компаниите, които хостват нашите страници в социалните медии, могат да ни предоставят обобщена информация и анализ за нашите дейности в социалните медии.',
    subBlock5:
      'Логови данни: Информация, автоматично изпращана от вашия браузър при използване на нашите услуги. Логовите данни включват вашия интернет протоколов (IP) адрес, тип и настройки на браузъра, датата и часа на вашите заявки, както и начина, по който взаимодействате с нашия уебсайт.',
    subBlock6:
      'Данни за употреба: Може да събираме автоматично информация за използването на услугата от ваша страна, като например видите или взаимодействате с какви типове съдържание, кои функции използвате, какви действия предприемате, както и вашия часови пояс, държава, дата и час на достъп, потребителски агент и версия, тип на компютъра или мобилното устройство и връзката на вашия компютър.',
    subBlock7:
      'Информация за устройството: Това включва името на устройството, операционната система, идентификатора на устройството и браузъра, който използвате. Собраната информация може да зависи от типа на устройството, което използвате, и неговите настройки.',
    subBlock8:
      'Бисквитки (cookies): Ние използваме бисквитки за функциониране и управление на нашите услуги, както и за подобряване на вашия опит. „Бисквитка“ (cookie) е информация, изпратена от уебсайта, който посещавате, към вашия браузър. Можете да конфигурирате вашия браузър да приема всички бисквитки, да отхвърля всички или да ви уведомява, когато се предлага бисквитка, за да можете да решавате дали да я приемате всеки път.倒是, отказът от бисквитки може да ви попречи да използвате или да засегне отрицателно показването или функционалността на определени области или функции на уебсайта. За повече информация относно бисквитките, моля посетете сайта All About Cookies.',
    subBlock9:
      'Аналитика: Може да използваме различни онлайн продукти за аналитика, които използват бисквитки, за да ни помогнат да анализираме как потребителите използват нашите услуги и да подобрим вашето изживяване при използване на услугите.',
    subTitle1: 'Лична информация, която събираме',
    subTitle2: 'Как използваме лични данни',
    subTitle3: 'Разкриване на лични данни',
    subTitle4: 'Вашите права',
    subTitle5: 'Връзки към други уебсайтове',
    subTitle6: 'Безопасност и задържане на информация',
    subTitle7: 'Модификация на Политиката за поверителност',
    subTitle8: 'Как да се свържете с нас',
    title: 'Политика за поверителност',
    updateTime: 'Обновено: 15 март 2024 г.',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Приеми всички',
    text: 'За да подобрим вашия опит, използваме бисквитки за персонализиране на съдържанието и услугите.',
    title: 'Този уебсайт използва бисквитки',
  },
  slogen: 'Най-лесният AI асистент',
  stripe: {
    contact: 'Свържете се с нас на contact@noam.tools с всякакви въпроси!',
    fail: {
      btn: 'Повторен опит',
      text1: 'Не можахме да обработим плащането ви.',
      text2: 'Проверете връзката си и опитайте отново.',
      title: 'Плащането не бе успешно',
    },
    succ: {
      btn: 'Хайде',
      text1: 'Добре дошли в Ноам',
      text2: 'да започнем!',
      title: 'Поздравления',
    },
  },
  terms: {
    block1: 'Благодаря, че използвате Noam!',
    block10:
      '(а) Такси и фактуриране. Трябва да платите всички такси („Такси“) в съответствие с цените и условията на съответната страница с цени или както е договорено в писмена форма между нас. Ние запазваме правото да коригираме грешки в цените или грешки, дори ако сме изписали фактури или получили плащане. Трябва да предоставите пълна и точна фактурна информация, включително валиден и упълномощен начин на плащане. Ще начисляваме на вашия начин на плащане периодично, както е договорено, но можем разумно да променим датата на фактуриране. Вие упълномощавате Noam, неговите филиали и трети страни обработващи плащания да начисляват на вашия начин на плащане. Ако вашето плащане не успее, ще ви изпратим писмено уведомление и можем да спрем достъпа до Услугата, докато не получим плащането. С изключение на случаите, различни посочени в този договор, плащанията са неизвъртени.',
    block11:
      '(б) Данъци. Ако не е посочено иначе, таксите не включват никакви федерални, държавни, местни и чуждестранни данъци, таможени пошлини и подобни начисления („Данъци“). Вие носите отговорност за всички данъци, свързани с вашите покупки, с изключение на данъците, основани на нашия нетен приход, за които ще ви фактурираме. Вие се съгласявате незабавно да платите такива данъци и да ни предоставите законно валидни декларации за поверителност и да получавате необходими съгласия за обработката на такива данни, като гарантирате на нас, че обработвате такива данни съгласно приложимото законодателство.',
    block12:
      '(в) Промени в цените. Може да променяме цените, уведомявайки ви чрез вашия акаунт и/или нашия уебсайт. Повышенията на цените ще влязат в сила незабавно след публикуването им. Всички промени в цените ще се прилагат за таксите на вашия акаунт след ефективната дата на промяната.',
    block13:
      '(d) Спорове и закъснели плащания. Ако искате да спорите какви да са таксите или данъците, моля, свържете се с contact@noam.tools в срок от тридесет (30) дни от датата на фактурата.',
    block14:
      '(e) Безплатно ползване. Не можете да създавате множество профили, за да получавате безплатни кредити. Ако установиме, че не ползвате безплатните кредити с добри намерения, можем да ви нарастваме стандартни такси или да спрем да предоставяме достъп до услугата.',
    block15:
      '(а) Конфиденциалност. Може да имате достъп до конфиденциална информация на Noam. Можете да използвате конфиденциалната информация единствено както е разрешено съгласно тези условия и за целта на ползването на Услугата. Не можете да разкривате конфиденциална информация на трети страни и трябва да я защитавате по начин, който да е не по-малко защитен от начина, по който защитавате вашата собствена подобна конфиденциална информация, поне с разумна грижа. Конфиденциална информация е непублична информация, обозначена като конфиденциална от Noam, или такава, която разумно трябва да се третира като конфиденциална при дадените обстоятелства, включително софтуер, спецификации и друга непублична бизнес информация. Конфиденциалната информация не включва информация, която: (1) става общо достъпна за публиката без вина от ваша страна; (2) сте имали в ваше притежание без каквато и да е обвързана с конфиденциалност задължение преди да я получите съгласно тези условия; (3) е законно разкрита на вас от трета страна без никакви обвързани с конфиденциалност задължения; или (4) е независимо разработена от вас без използване на конфиденциалната информация. Можете да разкривате конфиденциална информация, ако това е изисквано по закон, решение на съд или друго правителствено заповед, но трябва да дадете предварително писмено уведомление на Noam по разумен начин и, доколкото е възможно, да направите разумни усилия за ограничаване на обхвата на разкриването, включително да ни помогнете в опозицията срещу исканията за разкриване.',
    block16:
      '(б) Безопасност. Трябва да прилагате разумни и подходящи мерки, за да защитавате достъпа ви до услугата и нейното използване. Ако откриете някакви уязвимости или нарушения, свързани с използването на услугата, трябва незабавно да се свържете с Ноам и да предоставите подробности за уязвимостта или нарушението.',
    block17:
      '((в) Обработка на лични данни. Ако използвате Услугата за обработка на лични данни, трябва да предоставите законно достатъчни декларации за поверителност и да получавате необходими съгласия за обработка на такива данни, и гарантирате ни, че обработвате такива данни съгласно приложимото законодателство.',
    block18:
      '(а) Прекратяване; Приспиване. Тези условия ще влязат в сила от първото ви използване на Услугата и ще останат в сила докато не бъдат прекратени. Можете да прекратите тези условия по всяко време и по всяка причина, като спрете да използвате Услугата и Съдържанието. Ние можем да прекратим тези условия с предварително уведомление по всяка причина. Ние можем незабавно да прекратим тези условия, като ви уведомим, ако нарушите по существен начин Раздел 2 (Изисквания за използване), Раздел 5 (Конфиденциалност, сигурност и защита на данни), Раздел 8 (Решаване на спорове) или Раздел 9 (Общи условия), или ако нашето взаимоотношение с който и да е трети доставчик на технологии, който не е под наш контрол, се промени, или за спазване на закон или запитвания на правителството. Ние можем да спрем вашия достъп до Услугата, ако не спазвате тези условия, или ако вашето използване представлява риск за сигурността за нас или за трета страна, или ако подозираме, че вашето използване е измамно или може да изложи нас или трета страна на отговорност.',
    block19:
      '(б) Ефекти на прекратяването. При прекратяване Вие трябва да спрете да ползвате услугата и незабавно да върнете или унищожите всяка конфиденциална информация, както ние указваме. Договорните клаузи, чиято природа изисква да останат в сила след прекратяване или изтичане на срока, включително, но не само, раздели 3 и 5-9, остават в сила.',
    block2:
      'Тези Условия за ползване се прилагат за вашето ползване на услугите на Noam, включително нашите интерфейси за програмиране на приложения, софтуер, инструменти, услуги за разработчици, данни, документация и уебсайт (общо наричани „Услуги“). чрез ползване на нашите Услуги, Вие се съгласявате да спазвате тези условия. Нашата Политика за поверителност обяснява как събираме и използваме лични данни.',
    block20:
      'Застраховане. Вие ще защитавате, ще обезпечавате и ще пазите нас, нашите филиали и нашия персонал от всякакви искове, загуби и разходи (включително адвокатски такси), произтичající от или свързани с вашето използване на Услугата, включително вашето Съдържание, вашето използване на продукти или услуги, свързани с Услугата, и вашето нарушаване на тези условия или приложимото законодателство.',
    block21:
      '(б) Отказ от отговорност. Услугата се предоставя „като е“. Въпреки законът, ние, нашите филиали и лицензодатели не дават никакви представяния или гаранции от какъвто и да е вид относно Услугата и не дават гаранции, включително, но не ограничено до гаранции за търговарност, пригодност за конкретна цел, удовлетворителен качествен стандарт, несъщиност на права и мирно ползване, както и всякакви гаранции, произтичащи от обичаен начин на търговия или употреба.',
    block22:
      '(в) Ограничаване на отговорността. Ние, нашите филиали нито нашите лицензодатели не носим отговорност за какви да е косвени, случайни, специални, последващи или наказателни вреди, включително загуба на печалба, загуба на репутация, загуба на ползване, загуба на данни или други нематериални загуби, дори ако сме били информирани за възможността на такива вреди. Съгласно тези условия нашата общая отговорност няма да надвишава таксите, които сте платили за Услугата в продължение на дванадесет (12) месеца преди предявяването на иск или сто американски долара ($100), whichever is greater. Ограниченията в този раздел се прилагат до максималната степен, позволена от приложимото законодателство.',
    block23:
      'Условията и вашето използване на услугите се регулират от законите на Съединените щати, с изключение на правилата на Съединените щати относно споровете между закони. Вашият достъп до приложението може да бъде обвързан и с други местни, държавни, национални или международни закони. Всички правни действия или производства, свързани с тези условия, ще бъдат представени изключително пред съдите на Съединените щати, и вие се съгласявате да подпаднете под личния юрисдикция на такива съдилища.',
    block24:
      '(а) Отношение между страните. Ноам и вие сте независимые изпълнители, и нито една страна няма право да представлява или обвързва другата страна или да поема задължения за другата страна без предварително писмено съгласие на другата страна.',
    block25:
      '(b) Използване на марката. Не можете да използвате името, логото или търговските марки на Noam или каквито и да било негови филиали без нашето предварително писмено съгласие.',
    block26:
      'Ако каквото и да е разпоредба от тези условия се установи като невалидна, незаконна или неприложима, останалите разпоредби ще останат в пълна сила и въздействие.',
    block3:
      'Ако сте под 18 години, трябва да получите разрешение от родителите или законните опекуните си, за да използвате услугата. Ако използвате услугата от името на друг човек или юридическо лице, трябва да имате авторизация да приети тези условия от тяхно име. При регистрацията за акаунт трябва да предоставите точна и пълна информация. Не можете да предоставяте своите данни за достъп или акаунт на който и да е извън вашата организация, и сте отговорни за всички дейности, извършвани с помощта на вашите данни за достъп.',
    block4:
      '(а) Използване на услугата. Можете да получавате достъп до услугата съгласно тези условия, и ние ви предоставяме ненадоволително право да я използвате. При използване на услугата трябва да спазвате тези условия и всички приложими закони. Ние и нашите филиали притежаваме всички права, собственика и интереси към услугата.',
    block5:
      '(б) Обратна връзка. Ние приветстваме обратна връзка, коментари, идеи, предложения и подобрения. Ако предоставите какъвто и да е такъв материал, можем да го използваме без никакви ограничения и без компенсация за вас.',
    block6:
      '(в) Ограничения. Вие не можете: (1) да използвате услугата по начин, който нарушава, апроприира или нарушава права на трети лица; (2) да извършвате обратно инженерство, декомпилиране, разбиране, превод или друг начин да опитвате да откривате изходния код или основните компоненти на моделите, алгоритмите и системите на услугата (освен ако такива ограничения не са забранени от приложимото законодателство); (3) да използвате изхода на услугата за разработване на модели, конкуриращи с Noam; (4) да извличате данни или изход от услугата чрез автоматични или програменни методи, освен ако е разрешено чрез API, включително скрейпинг, уеб харвестинг или уеб извличане на данни; (5) да представяте изхода на услугата като изкуствено генериран, когато не е такъв, или по друг начин да нарушавате нашите политики за ползване; (6) да купувате, продавате или прехвърляте API ключове без нашето предварително съгласие; или (7) да ни предоставяте лични данни на деца под 13 години или приложимата възраст за цифрово съгласие. Ще спазвате всички ограничения по честота и други изисквания в нашата документация.',
    block7:
      '(д) Услуги на трети страни. Всички софтуери, услуги или други продукти на трети страни, свързани с Услугата, се регулират от техните собствени условия, и ние не носим отговорност за продуктите на трети страни.',
    block8:
      '(а) Вашето съдържание. Можете да предоставяте входни данни („Вход“) на услугата и да получавате изходни данни („Изход“), генерирани и върнати въз основа на Входа (общо наречени „Съдържание“). Между страните, и доколкото е разрешено от приложимото законодателство, вие притежавате всички Входни данни. Noam може да използва Съдържанието за предоставяне и поддържане на услугата, спазване на приложимите закони и прилагане на нашите политики. Вие носите отговорност за Съдържанието, включително за осигуряване на това, че то не нарушава никакви приложими закони или тези условия.',
    block9:
      '(б) Точност. Изкуственият интелект и машинното обучение са бързо развиващи се области на изследване. Ние непрекъснато се стремим да подобряваме нашата услуга, за да я направим по-точна, надеждна, сигурна и полезна. Следователно, поради вероятностния характер на машинното обучение, използването на нашата услуга може да доведе до неточни резултати в определени случаи, които може да не отразяват точно реални личности, места или факти. Трябва да оценявате подходящо точността на всеки резултат въз основа на вашия случай на употреба, включително чрез ръчно преглеждане на резултатите.',
    subTitle1: 'Регистрация и достъп',
    subTitle10: 'Детайлируемост',
    subTitle2: 'Изисквания за употреба',
    subTitle3: 'Съдържание',
    subTitle4: 'Такси и плащане',
    subTitle5: 'Конфиденциалност, сигурност и защита на данни',
    subTitle6: 'Срок и прекратяване',
    subTitle7: 'Имunity; Отказ от отговорност; Ограничаване на отговорността',
    subTitle8: 'Управляващо право и юрисдикция',
    subTitle9: 'Общи условия',
    title: 'Условия на ползване',
    updateTime: 'Актуализиран: 15 март 2024 г.',
  },
  trialModal: {
    btn: 'Започнете сега (само 0,99 долара)',
    chat: 'ChatPDF',
    desc1: 'След вашия пробен период ще бъдете таксувани с годишна такса от 180 долара',
    desc2: 'Отказване по всяко време',
    focus: 'Фокусиране',
    hover: 'Превод при ховър',
    image: 'Превод на изображения',
    installBtn: 'Инсталирайте сега, за да получите подаръка си',
    memo: 'Управление на любими',
    pdf: 'Паралелен превод на PDF',
    realtime: 'Моментно превод',
    select: 'Превод на избор на думи',
    title: 'Добро пожалователен подарък',
    trialText: '7-дневна проба',
    video: 'Превод на видео',
    videoSummary: 'С резюме на видеото',
    web: 'Паралелен превод',
    webSummary: 'Уводна информация от уеб',
  },
  upgradeModal: {
    btn: 'Актуализиране сега',
    chat: {
      free: 'Достигнахте лимита на ChatPDF',
      pro: 'Достигнахте лимита на ChatPDF за този месец',
    },
    contactStr: 'Моля, изчакайте следващото нулиране или се свържете с нас на contact@noam.tools.',
    limitAlertStr: 'Достигнахте лимита на вашия безплатен план. Надстройте, за да продължите.',
    more: 'Преглед на плановете',
    pageLimit: { free: 'Достигнахте лимита на страниците на PDF' },
    title: 'Напомняне',
    upgradeAlertStr: 'Достигнахте лимита на вашия безплатен план. Надстройте, за да продължите.',
    upload: {
      free: 'Достигнахте лимита си за превод на PDF',
      pro: 'Достигнахте лимита си за превод на PDF файлове за този месец',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Присъединете се сега',
      label: 'Предимства за нови потребители:',
      remain: 'Остават само 30',
      text: 'Само 100 места на разположение! Забийте своето сега!',
    },
  },
  aiPdfTranslator: {
    title: 'Безплатен AI преводач на PDF: Превеждане на PDF с сравнение на всеки език',
    desc: 'Лесно превеждайте PDF файлове на всякакви езици с помощта на ИИ. Сравнете оригиналния и преведеният текст страни Варв страна, бързо и безплатно.',
    keywords: 'GPT-4, AI Assistant, Превод, Резюме, Фокус, ChatPDF, Мемо, ефективност',
    sourceToTarget: {
      title:
        'Безплатно средство за превод на PDF: превеждане на {{source}} на {{target}} безплатно',
      desc: 'Превеждайте вашите PDF файлове от всеки източник на език към вашия предпочитан език безплатно. Бързо, точно и сигурно превеждане на PDF файлове, придружено от напреднал ИИ.',
    },
    headerIntroduce: {
      title: 'Noam: По-от decât просто онлайн превод',
      introduce1: {
        title: 'Noam · PDF Reader',
        desc: '✨Превод страница по страница + Въпроси и отговори с ИИ. Бързо и точно превеждайте PDF файлове на вашия целеви език. Свободно задавайте въпроси относно съдържанието, за да獲ете по-дълбоко разбиране на вашите PDF файлове.',
      },
      introduce2: {
        title: 'Noam · Разширение за едновременно превод',
        desc: '👏Решете всички нужди за превод на уеб страници:',
        detail1: { title: 'Превод на уебстраница:', desc: 'Двубоен изглед страна до страна' },
        detail2: { title: 'Превод на думи:', desc: 'Бързо превод с едно кликване' },
        detail3: { title: 'Моментено превод: ', desc: 'Превеждайте думи или изречения незабавно.' },
        detail4: { title: 'Превод на изображение:', desc: 'Заменете изображенията с преведени.' },
        detail5: { title: 'Превод на видео: ', desc: 'Двуезични субтитри за по-добро прегледане.' },
        footer:
          'Насладете се на повече функции за четене, оперирани от AI, за по-intелигентен превод!',
      },
    },
    subtitle: 'Превод на PDF онлайн безплатно',
    introduce: {
      module1: {
        detail1: {
          title: 'Реално времево превод на PDF страни едно до друго',
          desc1:
            'Моментно показване на оригиналното и преведеното съдържание в синхронизиран, страни-ред layout',
          desc2: 'Лесно сравнете и двете версии с синхронизирано скролване',
          desc3: 'Запазвайте идентично форматиране за последователно четене',
        },
        detail2: {
          title: 'Точно подравняване и проверка на съдържанието',
          desc1: 'Перфектно подравняване между изходния и преведеният текст за лесно проверяване',
          desc2: 'Всеки сегмент от съдържанието съвпада точно въвVersion',
          desc3: 'Бързо откривайте и решавате различия в преводите за надеждни резултати',
        },
      },
      module2: {
        detail1: {
          title: 'Многочислени напреднали AI модели за точен превод',
          desc1:
            'Изберете измежду водещия AI модели, за да отговарят на вашите изисквания за превод',
          desc2: 'Осигурете оптимални резултати за различни типове документи и индустрии',
          desc3: 'Гъвкави опции на модели предоставят адаптирани решения за всеки сценарий',
        },
        detail2: {
          title: 'Напреднало превод на изкуствен интелект за всеки тип съдържание',
          desc1:
            'Моделът ни с мощен изкуствен интелект гарантира висока точност и разбиране на естествен език',
          desc2: 'Лесно работи с технически, академични и креативни документи',
          desc3: 'Доставя надеждни резултати за всички ваши нужди по превод',
          desc4:
            'Интелектуално адаптиране към различни типове съдържание за оптимална производителност',
        },
      },
      module3: {
        detail1: {
          title: 'Интелектуално взаимодействие с документи',
          desc1: 'Беседете лесно с вашите PDF и файлове с презентации с помощта на напреднали ИИ',
          desc2:
            'Моментално задавайте въпроси относно съдържанието на документа и получавате точни отговори',
          desc3: 'Бързо генерирайте концизни резюмета за дълги документи',
        },
        detail2: {
          title: 'Гъбава анализ на съдържанието и безпроблемна интеграция',
          desc1:
            'Извличане на ключови информация и анализ на сложни данни с възможности за разбиране, насърчавани от изкуствен интелект',
          desc2: 'Получаване на прозрения върху технически, академични или креативни материали',
          desc3:
            'Безпроблемно се интегрира с нашия PDF преводач за пълно решение за управление на документи',
        },
      },
      module4: {
        detail1: {
          title: 'Отвъд превод на PDF: Всичко-в-едно решение за превод на уеб страници',
          desc: 'Открийте нашето мощно разширение за паралелен превод, предназначено за всеки сценарий на онлайн четене.',
          desc1:
            'Превод на уеб страница: Насладете се на двуезично съдържание с синхронизиран изглед страница по страница',
          desc2: 'Превод на думи: Моментално превеждане на оцветени думи с едно кликване',
          desc3:
            'Моментено превод: Преведете всеки текст или изречение на място за бързо разбиране',
          desc4:
            'Превод на изображения: Автоматично замяна на оригиналните изображения с преведени версии',
          desc5: 'Превод на видео: гледайте видеа с двуезични субтитри за подобрен опит',
        },
      },
    },
    question: {
      title: 'Често задавани въпроси',
      answer1: {
        title: 'Дали Noam PDF Translator е безплатен за използване за превод на PDF файлове?',
        content:
          'Да, можете да превеждате PDF файлове безплатно с Sider PDF Translator! Ние предлагаме безплатен квота от 5 000 токена, който е достатъчен за превод на повечето обикновено срещани на пазара PDF документи. Ако трябва да преведете по-големи файлове или се нуждаете от напреднали функции, можете да изберете да се надградите към нашите премиум планове за още повече възможности.',
      },
      answer2: {
        title: 'Колко точен е преводачът Noam PDF?',
        content:
          'Noam PDF Translator предлага изключително точни преводи, като използва напреднала ИИ технология и дълбоко разбира контекста на документите ви. Въпреки че нито един автоматизиран превод не е безгрешен, нашият страни-едно-далеч екран ви позволява лесно да преглеждате и преработвате всеки превод, гарантирайки, че крайният резултат отговаря на вашите очаквания за качество. Опитайте надежден и точен PDF превод с Noam.',
      },
      answer3: {
        title: 'Мога ли да преведем сканирани PDF файлове?',
        content:
          'Да, можете да преведете сканирани PDF файлове с нашата вградена OCR (Optical Character Recognition) технология. Нашият системата автоматично извлича текст от сканирани документи и изображени PDF файлове, след което превежда съдържанието за вас. Това гарантира, че дори нередактируеми или само с изображения PDF файлове могат да бъдат точно преведени.',
      },
      answer4: {
        title: 'Колко време отнема преводът?',
        content:
          'Преводът е бърз и ефективен — повечето документи се обработват за секунди до няколко минути, в зависимост от тяхната дължина и сложност. Например, стандартен PDF с 10 страници обикновено се превежда за по-малко от 2 минути. Насладете се на бързо изпълнение на всички нужди за превод на документи!',
      },
      answer5: {
        title: 'Мога ли да запазя изгледа страница срещу страница за четене?',
        content:
          'Да, винаги можете да четете документите си страница до страница. Този подредба ви позволява лесно да сравните оригиналния и преведеният контент, осигурявайки лесно и ефективно четене.',
      },
    },
    freeTrial: 'Безплатен опит',
    toLanguage: { title: 'AI двойки за превод на PDF', item: '{{target}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'Блог',
      pricing: 'Ценообразуване',
      faq: 'ЧЗВ',
      features: 'Характеристики',
      button: 'Преведете сега',
    },
    hero: {
      upload: {
        title: 'Качи вашия PDF',
        desc: 'или влагайте и пускайте',
        highlight: 'Кликнете за разглеждане',
        max: 'Макс',
      },
      to: 'да',
      pill: 'AI-опowered PDF преводач',
      title: 'Безплатен преводач на PDF',
      model: 'GPT-4 & Claude',
      free: 'Безплатен пробен период',
      support: 'Поддръжка на OCR',
      translated: 'Преведено от Ноам',
      desc: 'Моментни, точни преводи, които запазват оригиналния подредба. Noam AI поддържа OCR и страни-една-докато-страна изгледи.',
      complete: 'Преводът е завършен',
    },
    ticker: {
      pdf: 'Превод на PDF',
      format: 'Запазване на формата',
      multi: 'Многоезичен',
      ocr: 'Технология за оптично разпознаване на символи (OCR)',
      side: 'Едно до друго',
      chat: 'Чат с PDF',
      web: 'Уеб превод',
      secure: 'Безопасно и лични',
    },
    comparison: {
      bad: {
        title: 'Стандартен превод',
        head: 'Загубена форматиране и контекст',
        text1: 'Грешка: Лайаутът е счупен. Изображенията са разместени грешно.',
        text2:
          'Текстът се пресича и шрифтовете са несигурни. Трудно за четене и непрофесионално...',
      },
      dump: { title: 'Извлечение на обикновен текст' },
      good: {
        title: 'Noam AI Превод',
        tag: 'Перфектен резултат',
        sub: 'Перфектно форматиране, осъзнавано на контекста',
      },
      title: 'Защо да изберете Noam AI?',
      desc: 'Не се опитвайте повече с превод чрез копиране- поставяне. Опитайте разликата между стандартните инструменти и нашия AI-обогатен контекстно-осъзнат превод.',
    },
    showcase: {
      title2: 'Какъвто и е език',
      title1: 'Любой документ',
      kicker: 'ПОДДЕРЖАНИ ДОКУМЕНТИ',
      carousel2: 'Архитектура',
      carousel1: 'Изкуство',
      carousel4: 'Медицина',
      note: 'Решаване на технически, академични и креативни документи с лекота.',
      carousel3: 'Академичен списание',
      carousel5: 'Финанси',
      carousel8: 'Политика',
      carousel6: 'Закон',
      carousel7: 'Договор',
    },
    features: {
      big: {
        title: 'Напреднали модели на ИИ (GPT-4, Claude)',
        desc: 'Изберете измежду водещия AI модели, за да отговарят на вашите изисквания за превод. Осигурете оптимални резултати за различни типове документи.',
      },
      grid1: {
        title: 'OCR Поддръжка',
        desc: 'Извличане и превод на текст от сканирани PDF файлове и изображения незабавно.',
      },
      grid2: {
        title: 'Експорт с висока резолюция',
        desc: 'Изтеглете преведените си документи в PDF формат с оригинален подредба.',
      },
      grid3: {
        title: 'Сравнение страница по страница',
        desc: 'Синхронизирано скролване за сравнение на оригиналния и преведеният текст.',
      },
      title1: 'Повече от просто превод',
      title2: 'Това е революция',
      line1: 'Техническо работно материално.pdf',
      line3: 'Модел: GPT-4o (Висока точност)',
      line2: 'Определяне на език: Английски...',
      line4: 'Преводът завършен (99% точност)',
    },
    testimonials: {
      review1: {
        role: 'Исследовател',
        content:
          'Noam AI ми спести часове при превода на академични статии. Разделеният изглед е невероятно полезен за проверка на технически термини.',
      },
      review2: {
        role: 'Глобален маркетолог',
        content:
          'Най-добрият преводач на PDF, който съм използвал. Поддържа перфектно оригиналния форматирането, което е от решаващо значение за нашите маркетингови презентации.',
      },
      review3: {
        role: 'Юридически консултант',
        content:
          'Точен и бърз. го ползвам за превод на договори, а функцията за OCR за сканирани документи работи безупречно.',
      },
      kicker: 'Обичано от потребителите',
      title: 'Какво казват потребителите ни',
    },
    cta: {
      title: 'Готови ли сте да прекъснете езикови бариери?',
      button: 'Започнете превод безплатно',
      hint: '',
      desc: 'Присъединете се към над 10 000 потребители и започнете да превеждате вашите документи с Noam AI днес.',
    },
    languagePairs: {
      title: 'AI двойки за превод на PDF от английски език',
      desc: 'Популярни посоки на превод, поддържани от Noam AI',
    },
    footer: {
      about: 'За нас',
      privacy: 'Политика за поверителност',
      contact: 'Свържете се с поддръжката',
    },
  },
}

export default TRANSLATION
